module.exports = _.reduce;


//////////////////
// WEBPACK FOOTER
// external "_.reduce"
// module id = 57
// module chunks = business-manager/mini-home business-manager/shoutout-popup business-manager/video-library-page shoutout/shoutout full-screen-modals/full-screen-modals mobile-overlay/mobile-overlay mobile/mobile widget/widget dashboard/dashboard app-settings/app-settings